/**
 * Vue 2.7 ships the composition API natively, but Galaxy still imports the standalone
 * @vue/composition-api plugin (which this project cannot install alongside Vue 2.7 —
 * it throws "expose is not a function"). Re-export Vue's own API and no-op the install.
 */
export * from 'vue';

export default { install() {} };
